import { useEffect } from "react";

const BASE = "The KPR Academy";
const ORIGIN = "https://www.thekpracademy.org";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-page SEO: title, description, keywords, canonical, Open Graph & Twitter.
 */
export default function useSeo({ title, description, keywords, path = "/", image }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BASE}` : `${BASE} | CBSE School in Coimbatore`;
    document.title = fullTitle;

    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index, follow");

    setLink("canonical", `${ORIGIN}${path}`);

    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", BASE);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${ORIGIN}${path}`);
    if (image) setMeta("property", "og:image", image);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);
  }, [title, description, keywords, path, image]);
}
